import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFigshareComponent } from './simple-icons-figshare.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFigshareComponent ],
    exports:      [ SimpleIconsFigshareComponent ],
    bootstrap:    []
})
export class SimpleIconsFigshareModule {}
